<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="设备编号" v-model="deviceId" clearable></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="物联网IMEI卡号" v-model="imei" clearable></el-input>
      </el-col>
    
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
    </el-row>
    <el-table
      :data="data"
      border
      row-key="id"
      stripe
      style="width: 100%"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="device_id" label="设备编号" width="160">
      </el-table-column>
      <el-table-column prop="imei" label="IMEI" width="180"> </el-table-column>
      <el-table-column prop="paramKey" label="参数名称">
      </el-table-column>
      <el-table-column prop="paramValue" label="参数内容">
      </el-table-column>
      <el-table-column prop="downTime" label="下发时间" width="180">
      </el-table-column>

      <el-table-column prop="description" label="说明" min-width="200">
        <template slot-scope="scope">
          <el-select v-model="configName" placeholder="请选择" size="small" style="width: 100%" @change="handleSelectChange(scope.$index,scope.row)">
            <el-option v-for="item in configList" :key="item.name" :label="item.desc" :value="item.name"></el-option>
          </el-select>
          <el-input v-model="scope.row.currentValue" ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="uploadStatus" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="handleClick(scope.row)">
            下发
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>
  
  <script>
import Pagination from "@/components/Pagination";
export default {
  name: "admin",
  data() {
    return {
      deviceId: "",
      imei: "",
      imsi: "",
      data: [],
      env: this.getEnv(),
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0
      },
      configList: [],
      configName: 'Gps_run',
      currentValue:'5'
    };
  },
  watch: {
    deviceId: {
      handler(newVal, oldVal) {
        if (newVal === '') {
          this.pagin.pageNum = 1;
          this.getList();
        }
      },
      deep: true,
    },
    imei: {
      handler(newVal, oldVal) {
        if (newVal === '') {
          this.pagin.pageNum = 1;
          this.getList();
        }
      },
      deep: true,
    },
  },
  async created() {
    if (this.$route.params.id) {
      this.deviceId = this.$route.params.id !== ':id' ? this.$route.params.id : '';
      this.tableHeight = document.documentElement.clientHeight - 200 + "px";
    } else {
      this.$router.go(-1);
    }
    this.getConfigList();
  },
  methods: {
    handleSelectChange(index,row){
      console.log(index,row,this.configName)
      const currentValue = this.configList.find(item => item.name === this.configName).currentValue || '';
      this.data.forEach(item => {
          item.currentValue = currentValue;
      })
    },
    getConfigList(){
      this.$http
        .get(`${this.env}/manage/serviceTopicDataDownload/configList`)
        .then((results) => {
          console.log('参数列表', results);
          if (results["data"]["code"] === 0) {

            this.configList = results["data"]["data"]["configList"];
            console.log('参数列表1', this.configList);
            this.currentValue = this.configList[0].currentValue || '';
            this.configName = this.configList[0].name || '';
          } else {
            this.$message({
              message: results["data"]["msg"],
              type: "error",
            });
          }
        });
    },
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.relevancePagin.pageNum = val;
    },
    handleClick(row) {
      // 处理点击事件，例如发送请求
      console.log('点击了下发按钮', row);
      const config = this.configList.find(item => item.name === this.configName);
      if (!config) {
        this.$message({
          message: "请选择正确的参数",
          type: "error",
        });
        return;
      }
      const params = {
        deviceId: row.device_id,
        imei: row.imei,
        commandType: 'CONFIG',
        paramType: config.type,
        paramValue: row.currentValue || config.currentValue,
        paramLength: config.length,
      };
      this.$http
        .post(`${this.env}/manage/serviceTopicDataDownload/downTopic`, params)
        .then((results) => {
          console.log(results);
          if (results["data"]["code"] === 200) {
            this.$message({
              message: "下发成功",
              type: "success",
            });
          } else {
            this.$message({
              message: results["data"]["msg"],
              type: "error",
            });
          }
        });
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
        topicType: "S/SET",
      };
      if (this.deviceId.trim() != "") {
        params.deviceId = this.deviceId;
      }
      if (this.imei.trim() != "") {
        params.imei = this.imei;
      }
      if (this.imsi.trim() != "") {
        params.imsi = this.imsi;
      }
      this.$http
        .post(`${this.env}/manage/serviceTopicDataDownload/list`, params)
        .then((results) => {
          console.log(results);
          const records = results["data"]["data"]["records"];
          // 解析 json_data 字段
          this.data = records.map(item => {
            let jsonData = {};
            try {
              jsonData = JSON.parse(item.json_data || '{}');
            } catch (e) {
              console.error('解析 json_data 失败:', e);
            }
            return {
              ...item,
              paramId: jsonData.paramId || '',
              paramKey: jsonData.paramKey || '',
              paramValue: jsonData.paramValue || '',
              applyTime: jsonData.applyTime || '',
              rebootRequired: jsonData.rebootRequired,
              description: jsonData.description || '',
              downTime: item.down_time || '',
              cmdData: item.cmd_data || '',
              configName: jsonData.paramKey || '',
              currentValue: this.currentValue || ''
            };
          });
          this.pagin.total = results["data"]["data"]["total"];
        });
    },
    
    getEnv() {
      if (location.host == "localhost:8080") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "dev.iotmanage.baitengfa.com") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "iotmanage.baitengfa.com") {
        return "https://iotmanage.baitengfa.com";
      }
    },

  },
  components: { Pagination },
};
</script>
  
  <style scoped>
.tab {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}
</style>